<template>
    <v-container class="pa-8" fluid>
        <v-row justify="center">
            <v-col md=6>
                <div class="headline">Preferences</div>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-col md=6>
                <v-switch v-model="showActiveMaterials" label="Show active materials only" hide-details></v-switch>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col md=6>
                <v-switch v-model="showPricing" label="Show pricing" hide-details></v-switch>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col md=6>
                <v-select :items="items"
                          v-model="pageSize"
                          label="Page size"
                          solo></v-select>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import appsettings from '../../appsettings.js';

    export default {
        data: () => ({
            isMounting: false,
            showActiveMaterials: false,
            showPricing: false,
            items: [],
            pageSize: 0
        }),
        methods: {
            ...mapActions(['loadVrsUserInfo', 'updateVrsUserInfo'])
        },
        computed: mapGetters(['getVrsUser']),
        watch: {
            showActiveMaterials: {
                handler() {
                    if (this.isMounting) { return; }
                    let vrsUser = this.getVrsUser;
                    vrsUser.showActiveMaterials = this.showActiveMaterials;
                    this.updateVrsUserInfo(vrsUser);
                }
            },
            pageSize: {
                handler() {
                    if (this.isMounting) { return; }
                    let vrsUser = this.getVrsUser;
                    vrsUser.pageSize = this.pageSize;
                    this.updateVrsUserInfo(vrsUser);
                }
            },
            showPricing: {
                handler() {
                    if (this.isMounting) { return; }
                    let vrsUser = this.getVrsUser;
                    vrsUser.showPricing = this.showPricing;
                    this.updateVrsUserInfo(vrsUser);
                }
            }
        },
        mounted() {

            //Added mounting flag and next tick to prevent race condition
            //Note: We can rely on NextTick here because, although async, the property notification is completed by nextTick
            this.isMounting = true;

            this.items = appsettings.config.pages;
            this.showActiveMaterials = this.getVrsUser.showActiveMaterials;
            this.showPricing = this.getVrsUser.showPricing;
            this.pageSize = this.getVrsUser.pageSize;


            this.$nextTick(function () {
                this.isMounting = false;
            });

           


        }
    }
</script>